export default __webpack_public_path__ + "static/media/logo.a8ccc1b6.png";